import axiosInstanceNew from "../lib/axiosinstanceNew";

const EhcCordination = class {

    constructor(){
        this.baseUrl="ehc_coordination";
    }

  async List(id) {
    return (await axiosInstanceNew.get(`${this.baseUrl}?parent_id=${id}`));
  }
  async Add(data= []) {
    return (await axiosInstanceNew.post(`${this.baseUrl}`,data));
  }
}

export default new EhcCordination();